import { render, staticRenderFns } from "./TabelaFazendasNotaFiscal.vue?vue&type=template&id=107312c0&lang=pug"
import script from "./TabelaFazendasNotaFiscal.vue?vue&type=script&lang=js"
export * from "./TabelaFazendasNotaFiscal.vue?vue&type=script&lang=js"
import style0 from "./TabelaFazendasNotaFiscal.vue?vue&type=style&index=0&id=107312c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports